/**
 * @fileOverview
 * @author iNahoo
 * @since 2018/6/20.
 */


import React, { PureComponent } from 'react';
import propTypes from 'prop-types';
import './style.less';

import { subscribeProps } from '../../utils/decorators/subscribeProps';

function mix(...classNames) {
  return classNames.reduce((last, cur) => {
    if (!cur) {
      return last;
    }
    if (typeof cur === 'string') {
      last.push(cur);
      return last;
    }
    if (cur instanceof Array) {
      return last.concat(cur);
    }
    if (typeof cur === 'object') {
      return last.concat(Object.keys(cur));
    }
    return last;
  }, []).join(' ');
}

@subscribeProps
class DialogWrapper extends PureComponent {
  static propTypes = {
    fixedClassName: propTypes.string, // 额外Class
    // animation: propTypes.bool, // 动画进入，todo 未实现
    fullScreen: propTypes.bool, // 是否全屏
    zIndex: propTypes.number, // zIndex
    displayShadow: propTypes.bool, // 是否展示阴影
    clickShadowToCancel: propTypes.bool, // 点击阴影时是否退出 todo 未实现
  };

  static defaultProps = {
    fixedClassName: '',
    fullScreen: true,
    displayShadow: true,
    zIndex: 1000,
    clickShadowToCancel: false,
  };

  doms = {
    fixed: null,
    wrapper: null,
  };

  constructor(props) {
    super(props);
    this.state = {};
  }

  subscribeProps = {};

  // componentDidMount() {
  //   this.doms.fixed.addEventListener('click', this.onShadowClick);
  // }

  // onMouseWheel = ($event) => {
  //   $event.stopPropagation();
  //   if ($event.target === this.doms.wrapper || $event.target === this.doms.fixed) {
  //   }
  // };

  onShadowClick = ($event) => {
    if ($event.target === this.doms.wrapper || $event.target === this.doms.fixed) {
      this.props.clickShadowToCancel && this.props.destroy();
    }
  };

  render() {
    const { fullScreen, displayShadow, zIndex, fixedClassName } = this.props;

    const getFixedClassName = () => {
      const c = [];
      fullScreen && c.push('full-screen');
      displayShadow && c.push('with-shadow');
      fixedClassName && c.push(fixedClassName);

      return c;
    };

    const getWrapperClassName = () => {

    };

    return (<div
      ref={(el) => { this.doms.fixed = el; }}
      onClick={this.onShadowClick}
      className={mix('functional-dialog-fixed-layer', getFixedClassName())}
      style={{ zIndex }}
    >
      <div
        ref={(el) => { this.doms.wrapper = el; }}
        className={mix('functional-dialog-wrapper-layer', getWrapperClassName())}
      >
        {this.props.children}
      </div>
    </div>);
  }
}

export default DialogWrapper;



// WEBPACK FOOTER //
// ./src/components/FunctionalDialog/DialogWrapper.jsx